<template>
    <div v-cloak>
        <b-card no-body class="box-primary">
            <load-spinner :loading="isLoading" />
            <div
                slot="header"
                class="d-flex"
            >
                <h3 class="box-title">
                    <i class="far fa-list-alt"></i> Training Plan
                </h3>
                <div class="box-tools ml-auto mr-auto">
                    <small>PACKAGING RULES</small><br>
                    <span class="badge badge-danger">
                        {{ core }} Core Units ({{ currentCore }} Selected)
                    </span><br>
                    <span class="badge badge-info">
                        Minimum of {{ minElectives }} Electives ({{ electives }} Selected)
                    </span><br>
                    <span class="badge badge-secondary">
                        Maximum Funded Hours {{ maxHours }} ({{ hours }} H)
                    </span><br><br>
                    <b-btn
                        variant="primary"
                        @click="createTrainingPlan"
                        v-if="mode != 'listen'"
                    >
                        Create Training Plan
                    </b-btn>
                    <b-form-checkbox
                        v-if="mode != 'listen' && abilities.includes('override-packaging-rules')"
                        v-model="overridePackagingRules"
                        class="mt-2"
                    >
                        Override Packaging Rules
                    </b-form-checkbox>
                </div>
            </div>

            <div class="col-3" v-if="mode == 'broadcast'">
                Generic Training Plans
                <v-select
                    :options="genericTrainingPlans"
                    :clearable="false"
                    @change="genericTrainingPlan"
                    v-model="selectedGenericTrainingPlan"
                />
            </div>

            <b-tabs
                card
            >
                <b-tab
                    v-for="level in [1,2,3,4]"
                    :key="'level-' + level"
                    :title="'Level ' + level"
                >
                    <b-table
                        :fields="fields"
                        :items="levelCompetencies(level)"
                        show-empty
                    >
                        <template
                            v-slot:cell(HEAD_checkbox)="row"
                        >
                            <b-btn
                                variant="outline-primary"
                                size="sm"
                                @click="selectAll(level)"
                                :disabled="mode == 'listen'"
                            >
                                Select All
                            </b-btn>
                        </template>
                        <template
                            v-slot:cell(CourseType)="row"
                        >
                            <span class="badge badge-danger" v-if="row.item.CourseType == 'c'">
                                Core
                            </span>
                            <span class="badge badge-info" v-else-if="row.item.CourseType == 'e'">
                                Elective
                            </span>
                            <span class="badge badge-info" v-else-if="row.item.CourseType == 's'">
                                Stream
                            </span>
                            <span class="badge badge-info" v-else-if="row.item.CourseType == 'u'">
                                Unspecified
                            </span>
                        </template>
                        <template
                            v-slot:cell(Hours)="row"
                        >
                            {{ Number(row.item.Hours) }}
                        </template>
                        <template
                            v-slot:cell(Cluster)="row"
                        >
                            <b-dropdown
                                :id="'level-' + row.item.id"
                                :no-caret="true"
                                variant="outline-secondary"
                                size="sm"
                                no-flip
                                toggle-class="rounded"
                                boundary="window"
                                :disabled="mode == 'listen'"
                            >
                                <template
                                    slot="button-content"
                                >
                                    <span
                                        v-if="row.item.tp_level"
                                        :ref="'levelspan-' + row.item.Code"
                                    >
                                        {{ row.item.tp_level }}
                                    </span>
                                </template>
                                <b-dropdown-item-button
                                    v-for="l in ['1','2','3','4']"
                                    :key="row.item.id + '-' + l"
                                    @click="changeLevel(row.item, l)"
                                >
                                    {{ l }}
                                </b-dropdown-item-button>
                            </b-dropdown>
                        </template>
                        <template
                            v-slot:cell(checkbox)="row"
                        >
                            <span v-if="enrolmentsWithGradesCodes.includes(row.item.Code)">
                                <i class="fas fa-check"></i>
                            </span>
                            <b-form-checkbox
                                v-else
                                @change="competencyChange(row)"
                                :ref="'competencyCheckbox-' + row.item.CompetencyID"
                                :checked="initialCheckboxValue(row)"
                                :disabled="mode == 'listen'"
                            />
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
/* global _ */
/* global Noty */
/* global axios */

export default {
    mixins: [
    ],
    props: {
        student: {
            type: Object,
            required: true,
        },
        portfolio: {
            type: Number,
            default: 0,
        },
        mode: {
            type: String,
            default: 'listen'
        },
        createdurl: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            isLoading: false,
            fields: [
                {key: 'CourseType', label: 'Type'},
                {key: 'Code', label: 'Competency Code'},
                {key: 'Title', label: 'Description'},
                {key: 'Hours', label: 'Hours'},
                {key: 'Cluster', label: 'Level'},
                {key: 'checkbox', label: 'Check'}
            ],
            competencies: [],
            core: 0,
            currentCore: 0,
            electives: 0,
            hours: 0,
            maxHours: 0,
            minElectives: 0,
            selectedCompetencies: [],
            genericTrainingPlans: [],
            selectedGenericTrainingPlan: [],
            enrolmentsWithGradesCodes: [],
            enrolmentsWithGradesCore: 0,
            enrolmentsWithGradesElective: 0,
            enrolmentsWithGradesHours: 0,
            enrolments: [],
            levels: [],
            listenTime: 2000,
            listenSameCount: 0,
            listenSameID: null,
            listenTimeoutCount: 300,
            abilities: window.Auth ? window.Auth.abilities : [],
            overridePackagingRules: false,
        };
    },
    validations: {
    },
    watch: {
        //
    },
    mounted() {
        this.setInitalData();
        if (this.mode == 'listen') {
            this.nextListen();
        } else {
            this.fetchGenericTrainingPlans();
            this.sendUpdateMessage();
        }
    },
    methods: {
        levelCompetencies: function (level) {
            return this.competencies.filter(c => c.Cluster == level);
        },
        initialCheckboxValue: function (row) {
            let codeArr = this.pluck(this.enrolments, 'code');
            if (codeArr.includes(row.item.Code)) {
                return true;
            } else {
                return false;
            }
        },
        competencyChange: function (row) {
            let index = this.selectedCompetencies.findIndex(c => c.CompetencyID == row.item.CompetencyID);
            if (index == -1) {
                this.selectedCompetencies.push(row.item);
            } else {
                this.selectedCompetencies.splice(index, 1);
            }
            this.updatePackagingRules();
            this.sendUpdateMessage();
        },
        sendCreatedMessage: function () {
            let levels = this.competencies.map(c => { var levelsObj = { code: c.Code, level: c.tp_level }; return levelsObj });
            axios
                .post('/bki/api/messages', {
                    channel: 'tp.' + this.student.id,
                    event: 'CreatedTrainingPlan',
                    payload: {
                        competencies: this.selectedCompetencies,
                        levels: levels
                    },
                });
        },
        sendUpdateMessage: function () {
            let levels = this.competencies.map(c => { var levelsObj = { code: c.Code, level: c.tp_level }; return levelsObj });
            axios
                .post('/bki/api/messages', {
                    channel: 'tp.' + this.student.id,
                    event: 'UpdateTrainingPlan',
                    payload: {
                        competencies: this.selectedCompetencies,
                        levels: levels
                    },
                });
        },
        checkUpdateMessage: function () {
            axios
                .get('/api/messages', {
                    params: {
                        channel: 'tp.' + this.student.id,
                        latest: 'UpdateTrainingPlan,CreatedTrainingPlan'
                    }
                })
                .then((response) => {
                    if (_.isEmpty(response.data.data)) {
                        if (this.listenSameID == null) {
                            this.listenSameCount++;
                        } else {
                            this.listenSameID == null;
                            this.listenSameCount = 0;
                        }
                    } else {
                        let message = response.data.data[0];
                        if (message.id == this.listenSameID) {
                            this.listenSameCount++;
                        } else if (message.event == 'UpdateTrainingPlan') {
                            this.listenSameID = message.id;
                            let payload = JSON.parse(message.payload);
                            window.payloadtest = payload;
                            this.syncPayload(payload);
                        } else if (message.event == 'CreatedTrainingPlan') {
                            this.listenSameID = message.id;
                            if (this.createdurl != '') {
                                window.location = this.createdurl;
                            }
                        }
                    }
                });
        },
        nextListen: function () {
            if (this.listenSameCount == this.listenTimeoutCount) {
                new Noty({
                    type: 'error',
                    text: 'Listener has timed out, refresh the page to continue use',
                    layout: 'center',
                    modal: true,
                    timeout: false,
                }).show();
            } else {
                setTimeout(() => {
                    this.checkUpdateMessage();
                    this.nextListen();
                }, this.listenTime);
            }
        },
        setInitalData() {
            this.core = this.student.course.core;
            this.minElectives = this.student.course.minElectives;
            this.maxHours = this.student.course.maxHours;

            this.enrolments = this.student.enrolments.filter(e => e.code == e.element_code);
            this.enrolments = this.enrolments.filter(e => e.course_id == this.student.course.id);
            this.competencies = this.student.course.competencies.filter(c => c.CourseType == 'c' && c.Active == "YES");
            let others = this.student.course.competencies.filter(c => c.CourseType != 'c' && c.Active == "YES");
            this.competencies.push(...others);

            this.competencies.forEach(c => c.tp_level = c.Cluster);

            let enrolmentsWithGrades = this.enrolments.filter(e => e.result != '' && e.result != null);
            this.enrolmentsWithGradesCodes = this.pluck(enrolmentsWithGrades, 'code');
            this.enrolmentsWithGradesCore = enrolmentsWithGrades.filter(e => e.type == 'C').length;
            this.enrolmentsWithGradesElective = enrolmentsWithGrades.filter(e => e.type != 'C').length;
            this.enrolmentsWithGradesHours = this.pluck(enrolmentsWithGrades, 'hours').reduce((a,b) => Number(a) + Number(b), 0);

            let enrolmentsWithoutGrades = this.enrolments.filter(e => e.result == '' || e.result == null);
            let mappedCompetencies = enrolmentsWithoutGrades.map(e => this.competencies.find(c => c.Code == e.code)).filter(c => c != undefined);
            this.selectedCompetencies.push(...mappedCompetencies);

            this.enrolments.forEach(e => {
                const found = this.competencies.find(c => c.Code == e.code);
                if (found) {
                    found.tp_level = e.level;
                }
            });

            this.updatePackagingRules();
        },
        fetchGenericTrainingPlans: function () {
            return axios
                .get(`/bki/api/courses/${this.student.course_id}/genericTrainingPlan`)
                .then((response) => {
                    this.genericTrainingPlans = response.data;
                });
        },
        pluck: function (array, key) {
            return array.map(o => o[key]);
        },
        updatePackagingRules() {
            this.hours = this.pluck(this.selectedCompetencies, 'Hours').reduce((a,b) => Number(a) + Number(b), 0);
            this.currentCore = this.selectedCompetencies.filter(c => c.CourseType == 'c').length;
            this.electives = this.selectedCompetencies.length - this.currentCore;

            this.hours += this.enrolmentsWithGradesHours;
            this.currentCore += this.enrolmentsWithGradesCore;
            this.electives += this.enrolmentsWithGradesElective;
        },
        syncPayload(payload) {
            payload.levels.forEach(l => {
                let competency = this.competencies.find(c => c.Code == l.code);
                if (competency != undefined) {
                    this.changeLevel(competency, l.level);
                }
            });

            let payloadSelectedCompetencies = payload.competencies.map(c => this.competencies.find(c2 => c.Code == c2.Code)).filter(c => c != undefined);

            this.selectedCompetencies = [];
            this.selectedCompetencies.push(...payloadSelectedCompetencies);

            this.syncCheckboxes();
            this.updatePackagingRules();
        },
        syncCheckboxes() {
            let selectedCompetencyIDs = this.pluck(this.selectedCompetencies, 'CompetencyID');
            for (let i = 0; i < this.competencies.length; i++) {
                if (this.enrolmentsWithGradesCodes.includes(this.competencies[i].Code)) {
                    continue;
                }
                if (selectedCompetencyIDs.includes(this.competencies[i].CompetencyID)) {
                    this.$refs['competencyCheckbox-' + this.competencies[i].CompetencyID][0].localChecked = true;
                } else {
                    this.$refs['competencyCheckbox-' + this.competencies[i].CompetencyID][0].localChecked = false;
                }
            }
        },
        genericTrainingPlan(plan) {
            if (!_.isEmpty(plan)) {
                this.isLoading = true;
                axios
                    .get(`/bki/api/courses/${this.student.course_id}/genericTrainingPlan/${plan}`)
                    .then((response) => {
                        this.selectedCompetencies = response.data.filter(c => !this.enrolmentsWithGradesCodes.includes(c.Code));
                        this.sendUpdateMessage();
                        this.syncCheckboxes();
                        this.updatePackagingRules();
                        this.selectedGenericTrainingPlan = [];
                        this.isLoading = false;
                        new Noty({
                            type: 'info',
                            text: "Using Generic Training Plan: <b>" + plan + "</b>",
                            modal: false,
                            timeout: 5000,
                            killer: true,
                        }).show();
                    });
            }
        },
        createTrainingPlan() {
            var err = '';
            if (this.currentCore < this.core) {
                err = '<br>- Core: <b>' + this.currentCore + " of " + this.core + "</b>";
            }
            if (this.electives < this.minElectives) {
                err += '<br>- Elective: <b>' + this.electives + " of " + this.minElectives + "</b>"
            }
            if (this.hours > this.maxHours) {
                err += '<br> - Over Max Funded Hours: <b>' + this.hours + "H</b> of <b>" + this.maxHours + "H</b>"
            }
            if (err != '' && this.overridePackagingRules == false) {
                new Noty({
                    type: 'error',
                    text: "Does not meet packaging rule:" + err,
                    modal: false,
                    timeout: 5000,
                    killer: true,
                }).show();
            } else {
                this.isLoading = true;
                let competencyIDs = this.pluck(this.selectedCompetencies, 'CompetencyID');
                let levels = this.competencies.map(c => { var levelsObj = { code: c.Code, level: c.tp_level }; return levelsObj });
                axios
                    .post(`/bki/api/createTrainingPlan/${this.student.id}`, {
                        competencies: this.selectedCompetencies,
                        levels: levels,
                        overridePackagingRules: this.overridePackagingRules
                    })
                    .then((response) => {
                        this.sendCreatedMessage();
                        new Noty({
                            type: 'success',
                            text: "Training Plan Created",
                            modal: false,
                            timeout: 5000,
                            killer: true,
                        }).show();
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        new Noty({
                            type: 'error',
                            text: error.response.data.message,
                            modal: false,
                            timeout: 5000,
                            killer: true,
                        }).show();
                    });
            }
        },
        changeLevel(competency, level) {
            competency.tp_level = level;
            this.$refs['levelspan-' + competency.Code][0].innerText = level;
            if (this.mode != 'listen') {
                this.sendUpdateMessage();
            }
        },
        selectAll(level) {
            let alreadySelected = this.pluck(this.selectedCompetencies, 'CompetencyID');
            let competencies = this.levelCompetencies(level);
            for (let i = 0; i < competencies.length; i++) {
                if (this.enrolmentsWithGradesCodes.includes(competencies[i].Code)) {
                    continue;
                }
                if (alreadySelected.includes(competencies[i].CompetencyID)) {
                    continue;
                }
                this.selectedCompetencies.push(competencies[i]);
            }
            this.sendUpdateMessage();
            this.updatePackagingRules();
            this.syncCheckboxes();
        },
    },
};
</script>
